import { FC, ReactElement, useMemo } from 'react';

import trans from '../../helpers/trans';
import { SkillBase } from '../../models/@competentNL/Skills/Skills';
import { SkillOption } from '..';

import './SkillList.scss';

interface SkillListProps {
    title: string;
    skills: SkillBase[];
    selectedSkills: SkillBase[];
    onSelectOption: (option: SkillBase) => void;
    className?: string;
}

const SkillList: FC<SkillListProps> = ({
    title,
    skills,
    selectedSkills,
    onSelectOption,
    className = '',
}): ReactElement => {
    const numberOfSelectedOptions = useMemo((): number => {
        const skillIds = skills.map(skill => skill.id);
        const selectedOptions = selectedSkills.filter(selectedSkill => skillIds.includes(selectedSkill.id));

        return selectedOptions.length;
    }, [skills, selectedSkills]);

    return (
        <div className={`skill-list ${className}`}>
            <div className="skill-list__title-wrapper">
                <h2 className="skill-list__title">
                    {title}
                </h2>

                {numberOfSelectedOptions > 0 ? (
                    <p className="skill-list__result-details">
                        {trans('compositions.skillsSelector.numberOfSelected', {
                            number: numberOfSelectedOptions,
                        })}
                    </p>
                ) : (
                    <p className="skill-list__result-details">
                        {trans('compositions.skillsSelector.numberOfResults', {
                            number: skills.length,
                        })}
                    </p>
                )}
            </div>

            <ul className="skill-list__list">
                {skills.map(option => (
                    <SkillOption
                        key={option.id}
                        option={option}
                        selectedOptions={selectedSkills}
                        onSelectOption={onSelectOption}
                    />
                ))}
            </ul>
        </div>
    );
};

export default SkillList;
